
import $ from "jquery"


const CONTAINER_SELECTOR = ".js-toggleable-container"
const ONEOFF_CLASS = "js-toggleable-mode-oneoff"
const TOGGLED_CLASS = "js-toggleable-state-oneoff-toggled"

const INIT_DONE_CLASS_NAME = "js--toggleable--init-done"


// === Hide toggle target on start or after AJAX ===
function initOneElement(element: Element) {
  const $this = $(element)

  if ($this.hasClass(INIT_DONE_CLASS_NAME)) {
    return
  }
  else {
    $this.addClass(INIT_DONE_CLASS_NAME)
  }

  if ($this.hasClass(ONEOFF_CLASS)) {
    if ($this.hasClass(TOGGLED_CLASS)) {
      return
    }
    else {
      // So that next time would be stopped
      $this.addClass(TOGGLED_CLASS)
    }
  }

  $this.toggleClass("is-toggled")
}


const onLoad = () => {
  // On document ready
  $(CONTAINER_SELECTOR).each((_idx, element) => {
    initOneElement(element)
  })

  // On AJAX success
  $(document).ajaxSuccess(() => {
    $(CONTAINER_SELECTOR).each((_idx, element) => {
      initOneElement(element)
    })
  })
  // === Hide toggle target on start or after AJAX ===
}


export default {
  onLoad: onLoad,
}
